import { render } from "./ImageLeftTextHigh.vue?vue&type=template&id=b06052d2&scoped=true"
import script from "./ImageLeftTextHigh.vue?vue&type=script&lang=js"
export * from "./ImageLeftTextHigh.vue?vue&type=script&lang=js"

import "./ImageLeftTextHigh.vue?vue&type=style&index=0&id=b06052d2&scoped=true&lang=css"

import exportComponent from "/Users/jessicabohland/Documents/Code/Website/gonsbachtal-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b06052d2"]])

export default __exports__